import { type AllProductDTO, type FpB2bProductCatalogDTO } from '@cart-services/types'
import { type CrossBrandMallTopSellerProduct } from '@hooks-api/types/dataModel/cross-brand-mall'
import { type Variation } from '@hooks-api/types/dataModel/products'
import { type ProductCardEntry } from '../types/product-card-entry'
import { buildVariationEntry } from './build-product-card-entry'

interface GetTopSellerProductCardsParams {
  topSellers: CrossBrandMallTopSellerProduct[]
  productCatalogDto: FpB2bProductCatalogDTO | undefined
  limit: number
}

/**
 * 把後端排好名次的熱銷清單轉成卡片資料。
 * 後端 `campaign_product.product_id` 塞的是 variation 維度的 id，所以要用 variation_id 反查母 product；
 * 反查不到（譬如商品下架）的 top seller 會被略過。
 */
export const getTopSellerProductCards = (params: GetTopSellerProductCardsParams): ProductCardEntry[] => {
  const { topSellers, productCatalogDto, limit } = params

  if (!productCatalogDto) return []

  const variationIndex = new Map<string, { product: AllProductDTO; variation: Variation }>(
    productCatalogDto.products
      .flatMap(category => category.all_product)
      .flatMap(product =>
        product.variations.map(variation => [String(variation.variation_id), { product, variation }] as const),
      ),
  )

  return [...topSellers]
    .sort((a, b) => a.rank - b.rank)
    .slice(0, limit)
    .flatMap<ProductCardEntry>((topSeller) => {
      const matched = variationIndex.get(topSeller.campaign_product.product_id)
      if (!matched) return []
      return [buildVariationEntry({
        product: matched.product,
        variation: matched.variation,
      })]
    })
}
